// export const BASE_URL = "http://localhost:3333/api/v1/cust/";
// export const TAX_URL = "http://localhost:3333/";
// export const IMAGE_URL = "http://localhost:3333/";
export const BASE_URL = "https://api.lindsaydrivein.net/api/v1/cust/";
export const TAX_URL = "https://api.lindsaydrivein.net/";
export const IMAGE_URL = "https://api.lindsaydrivein.net/";
export const API = {
  BASE_URL,
  IMAGE_URL,
  CUSTOMER_REGISTER: BASE_URL + "register-customer",
  CUSTOMER_LOGIN: BASE_URL + "login-customer",
  CUSTOMER_LOGOUT: BASE_URL + "logout-customer",
  CUSTOMER_PROFILE: BASE_URL + "customer-profile",
  UPDATE_CUSTOMER_PROFILE: BASE_URL + "customer-profile-update",
  UPDATE_CUSTOMER_PROFILE_IMAGE: BASE_URL + "customer-profile-update-image",
  UPDATE_CUSTOMER_ADDRESS: BASE_URL + "customer-address-update",
  GET_CUSTOMER_ADDRESS: BASE_URL + "customer-address-fetch",
  DELETE_CUSTOMER_ADDRESS: BASE_URL + "customer-address-delete",
  CUSTOMER_CHANGE_PASSWORD: BASE_URL + "customer-change-password",
  LIST_MOVIE_SCREEN: BASE_URL + "list-movie-screens",
  LIST_FOOD_CATEGORIES: BASE_URL + "list-categories",
  FETCH_TAX_SETTINGS: TAX_URL + "api/v1/fetch-tax-settings",
  LIST_PRODUCTBY_CATEGORYID: BASE_URL + "list-productBy-categoryId",
  LIST_FAQ: BASE_URL + "list-faq",
  LIST_SETTINGS: BASE_URL + "list-settings",
  LIST_POLICIES: BASE_URL + "fetch-policy",
  RESOLVE_COMPANY: BASE_URL + "resolve-company",
  ADD_TO_CART: BASE_URL + "add-to-cart",
  INCREMENT_CART: BASE_URL + "cart-increment",
  DECREMENT_CART: BASE_URL + "cart-decrement",
  FETCH_CART_ORDER: BASE_URL + "fetch-cart",
  DELETE_CART_ITEM: BASE_URL + "delete-cart-item",
  CLEAR_CART: BASE_URL + "clear-cart",
  CREATE_ONLINE_ORDER: BASE_URL + "create-online-order",
  FETCH_ONLINE_ORDER: BASE_URL + "fetch-online-orders",
};
